import { externalProgram } from "../../common_nextgen/utils/Constants";

export const formFields = [
  {
    section: "Section 1",
    name: "bscScheduleName",
    label: "Benefit Max Schedule",
    fieldLabel: "Benefit Max Schedule",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 35],
  },
  {
    section: "Section 1",
    name: "bscDescription",
    label: "Description",
    fieldLabel: "BSC Description",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 47],
  },
  {
    section: "Section 1",
    name: "bsdStepNumber",
    label: "Step",
    fieldLabel: "Step",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 11],
  },
  {
    section: "Section 1",
    name: "bmdScheduleCode",
    label: "Benefit Max Drug Status Schedule",
    fieldLabel: "Benefit Max Drug Status Schedule",
    type: "lookup",
    externalProgram: { default: "RCBDD001" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          { source: "bmdScheduleCode", target: "bmdScheduleCode" },
          { source: "bmdDescription", target: "bmdDescription" },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 35],
  },
  {
    section: "Section 1",
    name: "bmdDescription",
    label: "",
    fieldLabel: "BMD Description",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 47],
  },
  {
    section: "Section 1",
    name: "acpProdSelCode",
    label: "PSC",
    fieldLabel: "TCD Sbm Product Sel Code",
    type: "dropdown",
    dropdownCondition: "PSC Cod for PlNDC/GPI Lst",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [10, 19],
  },
  {
    section: "Section 1",
    name: "acpMultiSourceCode",
    label: "Multi-Source",
    fieldLabel: "TCD Generic Ind (MedSpan)",
    type: "dropdown",
    dropdownCondition: "Valid Generic Ind",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [11, 19],
  },
  {
    section: "Section 1",
    name: "acpAlternateCopay",
    label: "Alternate Copay",
    fieldLabel: "ACP Alternate Copay",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 19],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "Added",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 14],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "Changed",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 32],
  },
  {
    section: "Audit Fields",
    name: "addUserName",
    label: "User",
    fieldLabel: "User",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
];
